module.exports = __webpack_public_path__ + "5daa2cd4599bd2656f13241a5d307d6a.png";